import type { IFieldStatistic } from '@/interfaces/api/fieldStatistics'

function round2(n: number): number {
    return Math.round(n * 100) / 100
}

/**
 * Aproxima min, Q1, mediana, Q3, max a partir de mediana e IQR (análise de anomalias).
 * Usado para visualização comparativa período base vs. semana no boxplot.
 */
export function fiveNumberSummaryFromMedianIqr(median: number, iqr: number): IFieldStatistic | null {
    const m = Number(median)
    if (!Number.isFinite(m)) return null
    const iq = Math.max(Number(iqr) || 0, 0)
    const half = iq > 0 ? iq / 2 : Math.max(Math.abs(m) * 0.08, 0.5)
    const Q1 = m - half
    const Q3 = m + half
    const whiskerSpan = iq > 0 ? iq * 0.65 : half * 1.3
    return {
        min: round2(Q1 - whiskerSpan),
        Q1: round2(Q1),
        median: round2(m),
        Q3: round2(Q3),
        max: round2(Q3 + whiskerSpan),
    }
}
